/* eslint-disable @typescript-eslint/no-explicit-any */
import request from 'utils/request';

const debitCreditSettlementPlanService = {
  getRecipientList: (params: any) =>
    request.get('/dc/charterer-entity', { params }),
  getList: (params: any) =>
    request.get('/debit-credit-settlement-plans', { params }),

  getByPid: (pid: number) =>
    request.get(`/debit-credit-settlement-plan/${pid}`),
  create: (data: { type: string; debitor_pid: number; charger_pid?: number }) =>
    request.post('/debit-credit-settlement-plan', data),

  update: (pid: number | string, data: any) =>
    request.put(`/debit-credit-settlement-plan/${pid}`, data),

  updateStatus: (pid: number | string, status: string | number) =>
    request.patch(`/debit-credit-settlement-plan/${pid}/status`, { status }),

  delete: (pid: number | string) =>
    request.delete(`/debit-credit-settlement-plan/${pid}`)
};

export default debitCreditSettlementPlanService;
